// API для работы с Wildberries
import { api } from './client'
import {
  ProductsResponse,
  CheckResponse,
  BatchCheckResponse,
  RagStats,
  ComplianceCheck
} from '../types/wildberries'

export const wildberriesAPI = {
  // Проверить, подключён ли токен (пинг-запрос)
  verifyConnection: async (): Promise<boolean> => {
    try {
      await api.get('/products', { params: { limit: 1 } })
      return true
    } catch {
      return false
    }
  },

  // Получить список товаров (бэк сам использует сохранённый токен)
  fetchProducts: async (limit = 100, offset = 0): Promise<ProductsResponse> => {
    const response = await api.get('/products', { params: { limit, offset } })
    return response.data
  },

  // Проверить одну карточку
  checkProduct: async (
    nm_id: string,
    description: string,
    attributes: Record<string, any>
  ): Promise<CheckResponse> => {
    const response = await api.post('/rag/check', {
      product_description: description,
      product_attributes: { nm_id, ...attributes }
    })
    return response.data
  },

  // Проверить пакет карточек (автоматически получает их с WB)
  checkProductsBatch: async (limit = 10): Promise<BatchCheckResponse> => {
    const response = await api.post('/rag/products/check', { limit })
    return response.data
  },

  // Статистика RAG
  getRagStats: async (): Promise<RagStats> => {
    const response = await api.get('/rag/stats')
    return response.data
  },

  // Переиндексировать оферту (админ-функция)
  reindexOffer: async (clearExisting = false): Promise<{ success: boolean }> => {
    const response = await api.post('/rag/index', {
      pdf_directory: './data/pdfs',
      clear_existing: clearExisting
    })
    return response.data
  },

  // Получить результаты проверки для конкретного товара
  getCheckResult: async (nm_id: string): Promise<ComplianceCheck | null> => {
    try {
      const response = await api.get(`/rag/check/${nm_id}`)
      return response.data
    } catch {
      return null
    }
  },

  // Получить все результаты проверок
  getAllChecks: async (): Promise<ComplianceCheck[]> => {
    try {
      const response = await api.get('/rag/checks')
      return response.data.checks || []
    } catch {
      return []
    }
  },

  // История проверок
  getCheckHistory: async (limit = 50, offset = 0) => {
    const response = await api.get(`/history?limit=${limit}&offset=${offset}`)
    return response.data
  },

  getCheckHistoryItem: async (id: string) => {
    const response = await api.get(`/history/${id}`)
    return response.data
  }
}